import { useEffect, useState } from "react"

export function useFileDataUrl(file: File | null) {
  const [dataUrl, setDataUrl] = useState<string | undefined>(undefined)

  useEffect(() => {
    const reader = new FileReader()
    reader.onload = () => setDataUrl(reader.result as string)
    file && reader.readAsDataURL(file)
  }, [file])

  return dataUrl
}
